import { DATE_FORMAT } from "helpers/common";
import React from "react";
import { toast } from "react-toastify";

const Columns = ({ handleViewHandler }) => [
  {
    dataField: "username",
    text: "User",
    formatter: (_, row) => (
      <span className="text-capitalize">{row?.userDetails?.username}</span>
    ),
  },
  {
    dataField: "purchaseID",
    text: "Purchase ID",
    formatter: (_, row) => (
      <span className="text-capitalize">{row?.purchaseID}</span>
    ),
  },
  {
    dataField: "energyPackageDetails",
    text: "Energy Package",
    formatter: (_, row) => (
      <span className="text-capitalize">
        {row?.energyPackageDetails ? row?.energyPackageDetails?.name : "custom"}
      </span>
    ),
  },
  {
    dataField: "energy",
    text: "Energy",
    formatter: (_, row) => (
      <span className="text-capitalize">{row?.energy}</span>
    ),
  },
  {
    dataField: "amount",
    text: "Amount",
    formatter: (_, row) => (
      <span>
        {Number(row?.amount ?? 0).toFixed(2)}{" "}
        {(row?.currencySymbol || "").toUpperCase()}
      </span>
    ),
  },
  // {
  //   dataField: "prevEnergyBalance",
  //   text: "Prev Energy",
  //   formatter: (_, row) => <span className="text-capitalize">{row?.prevEnergyBalance}</span>,
  // },
  // {
  //   dataField: "newEnergyBalance",
  //   text: "New Energy",
  //   formatter: (_, row) => <span className="text-capitalize">{row?.newEnergyBalance}</span>,
  // },

  {
    dataField: "paymentType",
    text: "Payment Type",
    formatter: (_, row) => (
      <span className="text-capitalize">{row?.paymentType}</span>
    ),
  },

  // Crypto-specific columns:
  // {
  //   dataField: "transactionHash",
  //   text: "Transaction Hash",
  //   formatter: (_, row) => {
  //     if (row?.paymentType !== "crypto") return <span>--</span>;

  //     const hash = row?.transactionHash;
  //     const network = row?.network;
  //     const shortened = hash ? `${hash.slice(0, 4)}...${hash.slice(-4)}` : "";

  //     const baseUrl =
  //       network === "mainnet"
  //         ? "https://tonviewer.com/transaction/"
  //         : "https://testnet.tonviewer.com/transaction/";

  //     return (
  //       <a
  //         href={`${baseUrl}${hash}`}
  //         target="_blank"
  //         rel="noopener noreferrer"
  //         className="text"
  //       >
  //         {shortened}
  //       </a>
  //     );
  //   },
  // },
  // {
  //   dataField: "senderWalletAddress",
  //   text: "Sender Wallet Address",
  //   formatter: (_, row) => {
  //     if (row?.paymentType !== "crypto") return <span>--</span>;

  //     const address = row?.senderWalletAddress;
  //     const shortened = address ? `${address.slice(0, 4)}...${address.slice(-4)}` : "";

  //     const handleCopy = () => {
  //       if (address) {
  //         navigator.clipboard.writeText(address);
  //         toast.success("Wallet address copied!");
  //       }
  //     };

  //     return (
  //       <span
  //         className="text"
  //         style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
  //         onClick={handleCopy}
  //         title="Click to copy"
  //       >
  //         {shortened}
  //       </span>
  //     );
  //   },
  // },

  {
    dataField: "paymentStatus",
    text: "Status",
    formatter: (_, row) => (
      <span className="text-capitalize">{row?.paymentStatus}</span>
    ),
  },

  // Fiat-specific columns:
  // {
  //   dataField: "order_id",
  //   text: "Order ID",
  //   formatter: (_, row) => (row?.paymentType === "crypto" ? <span>--</span> : <span className="text-capitalize">{row?.order_id}</span>),
  // },
  // {
  //   dataField: "order_status",
  //   text: "Order Status",
  //   formatter: (_, row) => (row?.paymentType === "crypto" ? <span>--</span> : <span className="text-capitalize">{row?.order_status}</span>),
  // },

  // {
  //   dataField: "transactionCompletedAt",
  //   text: "Trx Completed At",
  //   formatter: (_, row) => <span className="text-capitalize">{row?.transactionCompletedAt ? DATE_FORMAT(row?.transactionCompletedAt) : "--"}</span>,
  // },
  {
    dataField: "date_created_utc",
    text: "Created At",
    formatter: (_, row) => (
      <span className="text-capitalize">
        {row?.date_created_utc && DATE_FORMAT(row?.date_created_utc)}
      </span>
    ),
  },
  {
    text: "Action",
    dataField: "action",
    formatter: (_, row) => (
      <button
        className="fas fa-eye"
        style={{
          fontSize: "16px",
          backgroundColor: "#fff",
          border: "none",
        }}
        title="view"
        onClick={() => handleViewHandler(row)}
      ></button>
    ),
  },
];

export default Columns;
